import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export function WelcomeModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("dem_welcomed")) {
        const t = setTimeout(() => setOpen(true), 600);
        return () => clearTimeout(t);
      }
    } catch {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem("dem_welcomed", "1");
    } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm animate-fade-in" onClick={dismiss} data-testid="welcome-overlay" />
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 pointer-events-none">
        <div className="pointer-events-auto w-full max-w-md border border-white/10 bg-[#0B0F17] p-8 text-center animate-fade-in sm:p-10" data-testid="welcome-modal">
          <img src="/logo.png" alt="DetroitEmoto" className="mx-auto h-20 w-auto" data-testid="welcome-logo" />
          <h2 className="mt-6 font-display text-3xl font-black uppercase tracking-tight text-white" data-testid="welcome-heading">
            Welcome to <span className="text-volt">DetroitEmoto</span>
          </h2>
          <p className="mt-3 text-sm text-slate-400" data-testid="welcome-text">
            Performance parts for Surron, Talaria and E-Ride — motors, controllers, forks, wheels and more, shipped from Detroit.
          </p>
          <button
            onClick={dismiss}
            className="mt-8 flex w-full items-center justify-center gap-2 bg-volt py-4 font-mono text-sm font-bold uppercase tracking-widest text-obsidian transition-colors hover:bg-white"
            data-testid="welcome-continue-button"
          >
            Continue <ArrowRight className="h-4 w-4" />
          </button>
          <Link
            to="/shop"
            onClick={dismiss}
            className="mt-3 block py-2 font-mono text-xs uppercase tracking-widest text-slate-500 transition-colors hover:text-volt"
            data-testid="welcome-shop-link"
          >
            Skip to shop
          </Link>
        </div>
      </div>
    </>
  );
}
